import { assemblyOperationsOfferedBy } from "../bench-work/plan-operations";
import { ToolType } from "../Tool";

/**
 * Screwed assembly's home. Like nailed joinery and the hammer, recipes
 * that need a drill are drill operations — a station without one can't
 * offer them. Which builds those are is a fact of each plan record
 * (`offeredBy: "drill"` in src/game/plans/); screws never come back as
 * pallet salvage, so these builds are the screw economy's anchor.
 */
export const drill: ToolType = {
  id: "drill",
  name: "Drill",
  description:
    "A cordless drill/driver. Screwed assembly is only available at a station with one mounted.",
  cost: 70,
  // A hand tool belongs on a bench, not clamped into a jointer's jig slot.
  compatibleMachines: ["workspace", "worktable1x1", "worktable1x2"],
  operations: assemblyOperationsOfferedBy("drill"),
};
